import { createContext, useContext, useEffect, useState } from "react";

// Synthetic sandbox session. NOT real authentication.
// Demo access codes select a role + permitted journey only.
const CODES = {
  admin: "centre_admin",
  booking: "booking",
  volunteer: "volunteer",
  v: "volunteer",
};

export const ROLE_LABEL = {
  centre_admin: "Centre Administrator",
  booking: "Booking Administrator",
  volunteer: "Volunteer / Group Leader",
};

const KEY = "mill_session";
const SessionContext = createContext(null);

export function SessionProvider({ children }) {
  const [session, setSession] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || null; } catch { return null; }
  });

  useEffect(() => {
    if (session) localStorage.setItem(KEY, JSON.stringify(session));
    else localStorage.removeItem(KEY);
  }, [session]);

  // returns role string on success, null on bad code
  const signIn = (code, token = null) => {
    const role = CODES[String(code || "").trim().toLowerCase()];
    if (!role) return null;
    setSession({ role, token: token || null });
    return role;
  };

  const resetSession = () => setSession(null);

  return (
    <SessionContext.Provider value={{ session, signIn, resetSession, ROLE_LABEL }}>
      {children}
    </SessionContext.Provider>
  );
}

export const useSession = () => {
  const ctx = useContext(SessionContext);
  if (!ctx) throw new Error("useSession must be used within SessionProvider");
  return ctx;
};

export const DEMO_CODES = [
  { code: "admin", label: "Centre Administrator" },
  { code: "booking", label: "Booking Administrator" },
  { code: "volunteer", label: "Volunteer / Group Leader" },
];
